import { render, staticRenderFns } from "./MapCard.vue?vue&type=template&id=99ea3ddc&scoped=true"
import script from "./MapCard.vue?vue&type=script&lang=js"
export * from "./MapCard.vue?vue&type=script&lang=js"
import style0 from "./MapCard.vue?vue&type=style&index=0&id=99ea3ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ea3ddc",
  null
  
)

export default component.exports